var map = {
	"./age_range/adolescence.png": 80285,
	"./age_range/adult.png": 9405,
	"./age_range/child.png": 18831,
	"./age_range/elderly.png": 25200,
	"./age_range/youngchild.png": 81271,
	"./issue_based/adolescent_pregnancy.png": 9903,
	"./issue_based/bedridden.png": 23748,
	"./issue_based/beggar.png": 62039,
	"./issue_based/disabled.png": 86575,
	"./issue_based/family_violence.png": 13775,
	"./issue_based/helpless.png": 66741,
	"./issue_based/hiv_affected.png": 44747,
	"./issue_based/homeless.png": 82937,
	"./issue_based/human_trafficking.png": 58115,
	"./issue_based/single_parents.png": 50941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44076;